export type MaskVariant = "maskMiddle" | "onlyShowLast4";

export function applyMask(text: string, variant: MaskVariant): null | string {
  return variant === "maskMiddle" ? maskMiddle(text) : onlyShowLast4(text);
}

export function maskMiddle(str: string | undefined, length = 5): null | string {
  if (typeof str !== "string") return null;
  if (str.length <= length * 2) return str;

  return `${str.slice(0, length)}...${str.slice(-length)}`;
}

export function onlyShowLast4(str: string | undefined): null | string {
  if (typeof str !== "string") return null;
  if (str.length <= 4) return str;

  return `****${str.slice(-4)}`;
}

// Wallet addresses read as 0x1234...abcd everywhere in the app: leading 6 (0x + 4) and trailing 4. Distinct
// from maskMiddle, which is symmetric and used for account numbers.
export function truncateAddress(address: null | string | undefined): null | string {
  if (typeof address !== "string") return null;
  if (address.length <= 10) return address;
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}
